import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import {
    resolveColorContext,
    type ContextFamily,
    type ContextTone,
} from '@quipex/shared/utils';

@Component({
    selector: 'qpx-skeleton',
    template: '',
    styleUrls: ['./skeleton.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.aria-label]': 'ariaLabel() || null',
        '[attr.aria-hidden]': 'ariaLabel() ? null : true',
        '[attr.role]': 'ariaLabel() ? "status" : null',
        '[style.aspect-ratio]': 'aspectRatio()',
        '[style.border-radius]': 'borderRadius()',
        '[style.--qpx-skeleton-base]': 'baseColor()',
        '[style.--qpx-skeleton-effective-height]': 'effectiveHeight()',
        '[style.height]': 'height()',
        '[style.min-height]': 'minHeight()',
        '[style.width]': 'width()',
    },
})
export class Skeleton {
    //#region Inputs
    public readonly context = input<ContextFamily>();
    public readonly tone = input<ContextTone>();
    public readonly width = input<string | null>(null);
    public readonly height = input<string | null>(null);
    public readonly minHeight = input<string | null>(null);
    public readonly aspectRatio = input<string | null>(null);
    public readonly borderRadius = input<string | null>(null);
    public readonly effectiveHeight = input('100%');
    public readonly ariaLabel = input('');
    //#endregion

    //#region State
    protected readonly baseColor = computed(() => {
        const family = this.context() ?? 'secondary';
        const tone = this.tone() ?? (this.context() ? 'default' : 'muted');
        const colors = resolveColorContext(family, tone);
        return `var(${this.context() === 'navigation' ? colors.foreground.variable : colors.surface.variable})`;
    });
    //#endregion
}
